import React from "react";

import { getAccordionEventKey } from "./utils";
import { useMe } from "../../../../hooks/queries";
import { LocationData } from "../../../../models/LocationData";
import { EditProfileButton } from "../../EditProfileButton";
import { canEditFacilityBasicInfo } from "../../EditProfileButton/utils";
import { EditProfileFormSectionKeys } from "../../EditProfileForm/const";

interface IEditPickupFieldButtonProps {
  pickupFieldKey: string;
  onOpenModal: (
    accordionEventKey?: EditProfileFormSectionKeys | null | undefined
  ) => void;
  locationData: LocationData;
}

export const EditPickupFieldButton = (props: IEditPickupFieldButtonProps) => {
  const { pickupFieldKey, onOpenModal, locationData } = props;

  const { data: me } = useMe();
  const canEditProfile = canEditFacilityBasicInfo(me, locationData);

  const accordionEventKey = getAccordionEventKey(pickupFieldKey);

  // If accordionEventKey is not defined, this means this pickup field's section has not been implemented yet
  // If the user cannot edit the profile, or there is no accordionEventKey, return nothing
  if (!accordionEventKey || !canEditProfile) {
    return null;
  }

  return (
    <EditProfileButton
      accordionEventKey={accordionEventKey}
      onOpenModal={onOpenModal}
      locationData={locationData}
    />
  );
};
